var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-profile"},[_c('div',[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":_vm.profile.logo,"alt":""}})]),_c('transition',{attrs:{"name":"layout-submenu-wrapper"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}]})]),_c('ImageForm',{ref:"imageModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }